const getUpgradeMxPlansDictionary = function (data) {
  const upgradeMxPlansDictionary = {
    trademo_intel_mx_free: {
      name: "Trademo intel mexico free",
      key: "trademo_intel_mx_free",
      upgradeMessageArrivalDate: "You have access to only historical data. To access complete data. ",
      upgradeMessageEmailAlert: "Never miss out on tracking important shipments.",
      upgradeMessageXlsDownload: "A small investment can unlock this great feature.",
      upgradeMessageLiveNotification: "You have access to historical data. To access complete data. ",
      dashboardUpgradeMessageEmailAlert: "Never miss out on tracking important shipments.",
      planFeatures: [
        "Access to Mexico Shipments Imports and Exports Data (Jan-Mar 2011)",
        "Search by Product Keyword, Mexican Entity and Foreign Entity",
        "Explore detailed functionality of Trademo Intel",
      ],
    },
    trademo_intel_mx_essential: {
      name: "Trademo intel mexico essential",
      key: "trademo_intel_mx_essential",
      upgradeMessageArrivalDate: "You have access to only last 3 months data. To access complete data.",
      upgradeMessageEmailAlert: "Wow! You have used 5 alerts under this plan. To set more alerts.",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments. To download these shipments - Please upgrade.",
      upgradeMessageLiveNotification: "Great! You have used more than 90% of your download limit in the current plan.",
      dashboardUpgradeMessageEmailAlert: "To set up more email alerts.",
      planFeatures: [
        "Last 3 months of US CBP Imports data from the date of search",
        "Up to 1000 unique Bill of lading per month",
        "Set up to 5 unique email alerts",
        "Unlimited Searches",
        "Bookmark potential importer and exporter profiles",
        "Our customer success managers are available to support you with queries.",
      ],
    },
    trademo_intel_mx_plus: {
      name: "Trademo intel mexico plus",
      key: "trademo_intel_mx_plus",
      upgradeMessageArrivalDate: "You only have access to 12 months data. To access complete data. ",
      upgradeMessageEmailAlert: "Wow! You have used 10 alerts under this plan. To set more alerts. ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments. To download these shipments - Please upgrade.",
      upgradeMessageLiveNotification: "Great! You have used more than 90% of your download limit in the current plan.",
      dashboardUpgradeMessageEmailAlert: "To set up more email alerts. ",
      planFeatures: [
        "Last 12 months of Mexico Shipments Imports and Exports data from the date of search",
        "Up to 6 million unique shipments per month",
        "Unlimited Searches",
        "Our customer success managers are available to support you with queries",
      ],
    },
    trademo_intel_mx_pro: {
      name: "Trademo intel mexico pro",
      key: "trademo_intel_mx_pro",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: [
        "Mexico Shipments Imports and Exports data since Jan 2011",
        "Up to 6 million unique shipments per month",
        "Unlimited Searches",
        "Our customer success managers are available to support you with queries.",
      ],
    },
    trademo_intel_mx_pro2: {
      name: "Trademo intel mexico pro",
      key: "trademo_intel_mx_pro2",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: ["Last 12 months shipments data ", "Unlimited searches per day", "120,000 shipment downloads per user annually"],
    },
    trademo_intel_mx_advanced: {
      name: "Trademo intel mexico advance",
      key: "trademo_intel_mx_advanced",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: ["Last 24 months shipments data ", "US Census Data based Product Trends for last 24 months", "300,000 shipment downloads per user annually"],
    },
    trademo_intel_mx_enterprise: {
      name: "Trademo intel mexico enterprise",
      key: "trademo_intel_mx_enterprise",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent Mexico Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: ["Jan 2011 - Present shipments data ", "Unlimited downloads per user"],
    },
  };
  return upgradeMxPlansDictionary;
};
exports.getUpgradeMxPlansDictionary = getUpgradeMxPlansDictionary;
